import { selectJobNumbersState } from 'modules/settings/submodules/clients/jobNumber/store/selectors';
import { IStore } from 'store/configureStore';

const selectCreateJobNumberState = (state: IStore) => selectJobNumbersState(state).createJobNumbers;

export const selectIsJobNumberCreating = (state: IStore) => selectCreateJobNumberState(state).isCreating;
export const selectIsCreateJobNumberModalOpen = (state: IStore) => selectCreateJobNumberState(state).isModalOpen;
